/* unplugin-vue-components disabled */import script from "./Paper.vue?vue&type=script&setup=true&lang=js"
export * from "./Paper.vue?vue&type=script&setup=true&lang=js"

import "./Paper.vue?vue&type=style&index=0&id=170985fb&lang=scss"

const __exports__ = script;

export default __exports__